import React, { Component } from 'react';
import {Link} from 'react-router-dom'
import '../App.css';

class NotFound extends Component {
    state = { }
    render() {
        return (
            // <link type="text/css" rel="stylesheet" href="css/style.css" />
            <div id="notfound">
		    <div className="notfound">
			<div className="notfound-404">
				<h3>Oops! Page not found</h3>
				<h1><span>4</span><span>0</span><span>4</span></h1>
			</div>
			<h2>we are sorry, but the page you requested was not found</h2>
            <div>
                <Link to='/'>
                    Go to Homepage
                </Link>
            </div>
		</div>
	</div>
        )
    }

}

export default NotFound;